import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  success: false,
};

export const bookingSlice = createSlice({
  name: 'booking',
  initialState,
  reducers: {
    addBooking: (state) => {
      state.loading = true;
      state.success = false;
    },
    successBooking: (state) => {
      state.loading = false;
      state.success = true;
    },
    failedBooking: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetBooking: (state) => {
      state.success = false;
      state.error = null;
    }
  },
});

export const { addBooking, successBooking, failedBooking, resetBooking } = bookingSlice.actions;
export default bookingSlice.reducer;
